/* =========================================================================
   COMPONENT: ATELIER TOAST
   ========================================================================= */
window.AtelierToast = (function() {
  var toastTimer;
  
  function show(msg) {
    var toast = document.getElementById('AtelierToast');
    if (!toast) return;
    
    toast.textContent = msg;
    toast.classList.add('is-visible');
    
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function() { 
      toast.classList.remove('is-visible'); 
    }, 3000);
  }
  
  return { show };
})();